import { css, FlattenSimpleInterpolation } from 'styled-components';

import LoaderContainer from '../../Loader/styled/LoaderContainer';
import StyledButtonContent from '../styled/StyledButtonContent';
import { ButtonProps } from '../types';

const loaderSize = (size: number): string => `
  width: ${size}em;
  height ${size}em;
  margin-top: -${size / 2}em;
  margin-left: -${size / 2}em;
`;

const buttonSize = (props: ButtonProps): FlattenSimpleInterpolation => {
  if (props.small) {
    return css`
      &,
      ${StyledButtonContent} {
        font-size: 14px;
        line-height: 20px;
      }
      padding: 4px ${props.spacey ? '24px' : '16px'} 6px;

      ${LoaderContainer} {
        ${loaderSize(1.5)};
      }
    `;
  }

  if (props.large) {
    return css`
      &,
      ${StyledButtonContent} {
        font-size: 16px;
        line-height: 24px;
      }
      padding: 10px ${props.spacey ? '42px' : '28px'} 12px;

      ${LoaderContainer} {
        ${loaderSize(2)};
      }
    `;
  }

  if (props.giant) {
    return css`
      &,
      ${StyledButtonContent} {
        font-size: 18px;
        line-height: 26px;
      }
      padding: 13px ${props.spacey ? '48px' : '32px'} 15px;

      ${LoaderContainer} {
        ${loaderSize(2)};
      }
    `;
  }

  return css`
    &,
    ${StyledButtonContent} {
      font-size: 15px;
      line-height: 24px;
    }
    padding: 6px ${props.spacey ? '21px' : '14px'} 8px;

    ${LoaderContainer} {
      ${loaderSize(1.5)};
    }
  `;
};

export default buttonSize;
